export const CRONO_SITUATION = {
  ACTIVE: 'ATIVO',
  EXPIRING: 'A_VENCER',
  EXPIRED: 'VENCIDO'
}

const CRONO_SITUATION_LABELS = {
  [CRONO_SITUATION.EXPIRING]: 'A VENCER'
}

export function cronoSituationLabel(situation) {
  return CRONO_SITUATION_LABELS[situation] || situation
}

export function cronoEffectiveSituation(chronotachograph) {
  if (!chronotachograph) return undefined

  return chronotachograph.effectiveSituation || chronotachograph.situation
}

export function cronoSituationFilterTable(situations) {
  return (situations || []).filter(Boolean).map(situation => [cronoSituationLabel(situation), situation])
}
